import { ScrollScene } from 'scrollscene';
import { gsap } from 'gsap';
import { $Elements, Breakpoints, BrowserEvents, Classes } from './constants';
import { DynamicScrollScene } from './helpers';

;(function($) {

	$Elements.document.on(BrowserEvents.page.enter, () => {

		//=====================================
		//	!---------- ANIMATIONS ----------
		//=====================================

		let dynanicScenes = [];
		const scrollTimelineDefaults = {
			paused: true,
			defaults: {
				ease: 'none',
			},

		};

		// ---------- Global ----------

		$('.animated-section:not(.transition-clone)').each(function() {

			const params = () => {

				return {
					triggerElement: this,
					triggerHook: 0.8,
					scene: { reverse: false },
					toggle: {
						element: this,
						className: Classes.active,
					}
				};
			};

			const scene = new ScrollScene(params());
		});

		// ---------- Parallax ----------

		$('.parallax-section:not(.fixed-parallax-section):not(.transition-clone)').each(function() {

			const params = () => {

				const image = this.querySelectorAll(':scope .parallax-image');
				const offset = 50;
				const timeline = gsap.timeline(scrollTimelineDefaults).fromTo(image, {
					y: '-' + offset + '%',
				}, {
					y: offset + '%',
				});

				return {
					triggerElement: this,
					triggerHook: 'onEnter',
					gsap: { timeline },
					duration: '200%',
					breakpoints: { 0: false, [Breakpoints.Menu]: true },
				};
			};

			const scene = new ScrollScene(params());
		});

		$('.first-text-image-section').each(function() {

			const params = () => {

				const text = this.querySelector(':scope .text-column');
				const offset = 30;
				const timeline = gsap.timeline(scrollTimelineDefaults).to(text, {
					y: offset + '%',
				});

				return {
					triggerElement: this,
					triggerHook: 'onEnter',
					gsap: { timeline },
					duration: '200%',
					breakpoints: { 0: false, [Breakpoints.Mobile]: true },
				};
			};

			const scene = new ScrollScene(params());
		});

		$('.simple-text-image-section, .bordered-text-image-section, .text-rows-section, .team-section, .tasting-section').each(function() {

			const params = () => {

				const moving = this.querySelectorAll(':scope .single-column:nth-child(even)');
				const offset = 15;
				const timeline = gsap.timeline(scrollTimelineDefaults).fromTo(moving, {
					y: '-' + offset + '%',
				}, {
					y: offset + '%',
				});

				return {
					triggerElement: this,
					triggerHook: 'onEnter',
					gsap: { timeline },
					duration: '200%',
					breakpoints: { 0: false, [Breakpoints.Mobile]: true },
				};
			};

			const scene = new ScrollScene(params());
		});

		$('.news-section').each(function() {

			const params = () => {

				const moving = this.querySelectorAll(':scope .single-column:nth-child(even)');
				const offset = 15;
				const timeline = gsap.timeline(scrollTimelineDefaults).fromTo(moving, {
					y: '-' + offset + '%',
				}, {
					y: offset + '%',
				});

				return {
					triggerElement: this,
					triggerHook: 'onEnter',
					gsap: { timeline },
					duration: '200%',
					breakpoints: { 0: false, [Breakpoints.Mobile]: true },
				};
			};

			const scene = new DynamicScrollScene(params);

			dynanicScenes.push(scene)
		});

		$Elements.document.on(BrowserEvents.animation.refresh, () => dynanicScenes.map(scene => scene.refresh()));
		$Elements.document.trigger(BrowserEvents.animation.refresh);

	});

}(jQuery));
